import { Box, IconButton, Avatar, Button, Tooltip, Badge, Typography } from '@mui/material';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import UserMenu from './UserMenu';
import React, { useState } from 'react';
import ShareDialog from '../components/ShareDialog';
import { getShareUrl, shareTitle, shareToApp, handleCopyLink } from '../utils/share';

export default function TopBar({
  isLogin,
  onLogin,
  onCouponClick,
  onShareClick,
  onAvatarClick,
  userMenuAnchor,
  onUserMenuClose,
  navigate,
  onLogout,
  hideActions = false,
  shareCount = 0,
}) {
  const [openShareDialog, setOpenShareDialog] = useState(false);

  const handleLogin = onLogin || (() => navigate && navigate('/campaigns/invitations/login?v=isAgentUser'));

  console.log('handleLogin',handleLogin);
  const inviteCode = localStorage.getItem('inviteCode') || '';
  const shareUrl = getShareUrl();
  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          zIndex: 1100,
          background: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
          borderBottom: '1px solid rgba(0, 0, 0, .06)',
        }}
      >
        <Box
          sx={{
            maxWidth: '1200px',
            mx: 'auto',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 2, md: 6 },
            height: { xs: 56, md: 64 },
          }}
        >
        <a href="https://utaxes.com/" target="_blank" rel="noopener noreferrer">
          <Box
            component="img"
            src={require("../assets/icons/utaxes.svg").default}
            alt="uTaxes"
            sx={{
              width: 120,
              height: "auto",
            }}
          />
        </a>

          {!hideActions && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 }, position: 'relative' }}>
              {isLogin ? (
                <>
                  {/* Share Button */}
                  <Tooltip 
                    title={
                      <Box sx={{ p: 1 }}>
                        <Typography sx={{ fontWeight: 600, mb: 1 }}>Share and Earn Rewards</Typography>
                        <Typography sx={{ fontSize: '13px', color: '#fff' }}>
                          • Individual Tax: You get $100, friend gets 1 month free
                        </Typography>
                        <Typography sx={{ fontSize: '13px', color: '#fff' }}>
                          • Business Tax: You get $200, friend gets 2 months free
                        </Typography>
                      </Box>
                    }
                    placement="bottom"
                    arrow
                  >
                    <Badge 
                      badgeContent={
                        <Box sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: 0.5,
                          color: '#fff',
                          fontSize: '12px',
                          fontWeight: 600
                        }}>
                          <MonetizationOnOutlinedIcon sx={{ fontSize: 16, color: '#FFD600' }} />
                          <span>$100</span>
                        </Box>
                      }
                      color="primary"
                      sx={{
                        '& .MuiBadge-badge': {
                          right: -3,
                          top: 3,
                          border: '2px solid #fff',
                          padding: '0 4px',
                          backgroundColor: '#007AFF',
                          minWidth: '40px',
                          height: '20px',
                          borderRadius: '10px',
                        }
                      }}
                    >
                      <IconButton
                        onClick={() => setOpenShareDialog(true)}
                        sx={{
                          ml: 1,
                          bgcolor: '#fff',
                          borderRadius: '14px',
                          border: '1px solid #E5E7EB',
                          transition: 'all 0.2s ease',
                          position: 'relative',
                          width: 40,
                          height: 40,
                          overflow: 'visible',
                          boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                          '&:hover': {
                            transform: 'translateY(-2px)',
                            bgcolor: '#f0f7ff',
                            boxShadow: '0 4px 12px rgba(0,122,255,0.15)',
                            borderColor: '#007AFF',
                          }
                        }}
                        aria-label="Share uTaxes"
                      >
                        <ShareOutlinedIcon sx={{ 
                           color: '#007AFF',
                           fontWeight: 600,
                           fontSize: '18px',
                           transition: 'color 0.3s ease',
                         }} />
                      </IconButton>
                    </Badge>
                  </Tooltip>
                  {/* Coupon Button */}
                  <IconButton
                    onClick={onCouponClick}
                    sx={{
                      ml: 1,
                      bgcolor: '#fff',
                      borderRadius: '14px',
                      border: '1px solid #E5E7EB',
                      transition: 'all 0.2s ease',
                      width: 40,
                      height: 40,
                      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        bgcolor: '#f8f8f8',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        borderColor: '#D1D5DB',
                      }
                    }}
                    aria-label="Coupons"
                  >
                    <CardGiftcardOutlinedIcon sx={{ 
                       color: '#031B4E',
                       fontWeight: 600,
                       fontSize: '18px',
                     }} />
                  </IconButton>
                  {/* User Button */}
                  <IconButton 
                    onClick={onAvatarClick}
                    sx={{
                      p: 0,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                      }
                    }}
                  >
                    <Avatar 
                      sx={{ 
                        bgcolor: '#007AFF',
                        color: '#fff',
                        fontWeight: 600,
                        fontSize: '16px',
                        width: 40,
                        height: 40,
                        boxShadow: '0 2px 6px rgba(0,122,255,0.2)',
                      }}
                    >
                      U
                    </Avatar>
                  </IconButton>
                  <UserMenu
                    anchorEl={userMenuAnchor}
                    open={Boolean(userMenuAnchor)}
                    onClose={onUserMenuClose}
                    navigate={navigate}
                    onLogout={onLogout}
                  />
                </>
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {/* Share Button for Non-logged in Users */}
                  <Tooltip
                    title={
                      <Box sx={{ p: 1 }}>
                        <Typography sx={{ fontWeight: 600, mb: 1 }}>Invite Friends & Earn Cash</Typography>
                        <Typography sx={{ fontSize: '13px', color: '#fff' }}>
                          • Get $100 for each friend you refer
                        </Typography>
                        <Typography sx={{ fontSize: '13px', color: '#fff' }}>
                          • Earn up to $200 for business referrals
                        </Typography>
                      </Box>
                    }
                    placement="bottom"
                    arrow
                  >
                    <Button
                      variant="contained"
                      onClick={handleLogin}
                      startIcon={
                        <MonetizationOnOutlinedIcon sx={{ color: '#fff', fontSize: 20 }} />
                      }
                      sx={{
                        bgcolor: "#007AFF",
                        color: "#fff",
                        borderRadius: "12px",
                        fontWeight: 600,
                        textTransform: "none",
                        px: 2,
                        height: 40,
                        fontSize: 14,
                        boxShadow: "0 2px 8px rgba(0,122,255,0.2)",
                        transition: 'all 0.2s ease',
                        fontFamily: 'SF Pro Text, -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
                        '&:hover': {
                          bgcolor: "#0062CC",
                          boxShadow: "0 4px 12px rgba(0,122,255,0.3)",
                          transform: 'translateY(-2px)'
                        },
                        '&:active': {
                          bgcolor: "#004999"
                        }
                      }}
                    >
                      Earn $100
                    </Button>
                  </Tooltip>
                  <Button
                    variant="outlined"
                    onClick={handleLogin}
                    sx={{
                      borderColor: "#D1D5DB",
                      color: "#031B4E",
                      bgcolor: "#fff",
                      borderRadius: "12px",
                      fontWeight: 600,
                      textTransform: "none",
                      px: 2,
                      height: 40,
                      fontSize: 14,
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      transition: 'all 0.2s ease',
                      fontFamily: 'SF Pro Text, -apple-system, BlinkMacSystemFont, Roboto, sans-serif',
                      '&:hover': {
                        bgcolor: "#F9FAFB",
                        borderColor: "#9CA3AF",
                        transform: 'translateY(-2px)',
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      },
                      '&:active': {
                        borderColor: "#6B7280",
                        bgcolor: "#F3F4F6"
                      }
                    }}
                  >
                    Login
                  </Button>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
      <ShareDialog
        open={openShareDialog}
        onClose={() => setOpenShareDialog(false)}
        shareUrl={shareUrl}
        shareTitle={shareTitle}
        shareToApp={shareToApp}
        handleCopyLink={handleCopyLink}
      />
    </>
  );
} 